import RemedialActions from "./RemedialActions";
import UpdateInspectionHistory from "./UpdateInspectionHistory";
import React, { useState } from "react";
import { useLocation } from "react-router";

interface TabButtonProps {
  id: string;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export const TabButton: React.FC<TabButtonProps> = ({
  id,
  label,
  isActive,
  onClick,
}) => {
  return (
    <button
      className={`inline-flex items-center border-b-2 px-2.5 py-2 text-sm font-medium transition-colors duration-200 ease-in-out ${
        isActive
          ? "text-[#142900] dark:text-brand-400 border-[#142900] dark:border-brand-400"
          : "bg-transparent text-gray-500 border-transparent hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200  hover:bg-[#ffffa3]"
      }`}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

interface TabContentProps {
  id: string;
  title: string;
  isActive: boolean;
  inspectionHoistory: any;
}

const TabContent: React.FC<TabContentProps> = ({ id, title, isActive, inspectionHoistory }) => {
  if (!isActive) return null;

  return (
    <div className="text-sm text-gray-500 dark:text-gray-400">
      {id === "Inspection History Record" && <UpdateInspectionHistory inspectionHoistory={inspectionHoistory} />}
      {id === "Remedial Actions" && <RemedialActions inspectionHoistory={inspectionHoistory} />}
    </div>
  );
};

const tabs = [
  { id: "Inspection History Record", label: "Inspection History Record" },
  { id: "Remedial Actions", label: "Remedial Actions" },
];

const InspectionHistoryTab: React.FC = () => {
  const [activeTab, setActiveTab] = useState("Inspection History Record");
  const location = useLocation();
  const inspectionHoistory = location.state?.inspectionHoistory;

  return (
    <div className="p-6 border border-gray-200 rounded-xl dark:border-gray-800">
      <div className="border-b border-gray-200 dark:border-gray-800">
        <nav className="-mb-px flex space-x-2 overflow-x-auto [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-200 dark:[&::-webkit-scrollbar-thumb]:bg-gray-600 dark:[&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar]:h-1.5">
          {tabs.map((tab) => (
            <TabButton
              key={tab.id}
              id={tab.id}
              label={tab.label}
              isActive={activeTab === tab.id}
              onClick={() => setActiveTab(tab.id)}
            />
          ))}
        </nav>
      </div>

      <div className="pt-4 dark:border-gray-800">
        {tabs.map((tab) => (
          <TabContent
            key={tab.id}
            id={tab.id}
            title={tab.label}
            isActive={activeTab === tab.id}
            inspectionHoistory={inspectionHoistory}
          />
        ))}
      </div>
    </div>
  );
};

export default InspectionHistoryTab;
